import PropTypes from "prop-types";
import React__default, { useState, useRef, useEffect } from "react";
import { u as useKeyboardListener } from "../../../hooks-BlwR7OOF.js";
import { Box } from "../Box/Box.js";
import { S as SvgUpArrow } from "../../../up_arrow-BZ6O1kyX.js";
import { a as isEmpty } from "../../../helpers-N4qF49_T.js";
/* empty css                               */
const DropdownSubMenu = ({
  value = null,
  items,
  onSelect,
  direction = "standard",
  style = {},
  selectedAtTop,
  // Whether to move the selected item to the top (or bottom if inverse)
  onClose,
  classes = null
}) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [sortedItems, setSortedItems] = useState(items || []);
  const [clickedItem, setClickedItem] = useState(null);
  const getItem = (itemValue) => {
    const itemIndex = sortedItems.findIndex((item) => item.value === itemValue);
    return sortedItems[itemIndex] || null;
  };
  getItem(value);
  const selectedClickedItem = getItem(clickedItem);
  const listRef = useRef(null);
  useEffect(() => {
    let newItems = items;
    if (selectedAtTop) {
      const showSelectedAtBottom = direction === "inverse";
      if (showSelectedAtBottom) {
        newItems = [
          ...items.filter((item) => (item == null ? void 0 : item.value) !== value),
          ...items.filter((item) => (item == null ? void 0 : item.value) === value)
        ];
      } else {
        newItems = [
          ...items.filter((item) => (item == null ? void 0 : item.value) === value),
          ...items.filter((item) => (item == null ? void 0 : item.value) !== value)
        ];
      }
    }
    setSortedItems(newItems);
  }, [items, value]);
  const onBlur = () => {
    var _a;
    if (document.activeElement !== listRef.current) {
      return;
    }
    (_a = document.activeElement) == null ? void 0 : _a.blur();
  };
  const dropdownStyles = {
    outerContainer: {
      // ...(style || {}),
      minWidth: "250px",
      ...(style == null ? void 0 : style.outerContainer) || {}
    },
    menu: {
      ...(style == null ? void 0 : style.menu) || {}
    },
    menuOpen: {
      ...(style == null ? void 0 : style.menuOpen) || {}
    },
    menuItem: {
      padding: "16px 20px",
      cursor: "pointer",
      // userSelect: 'none',
      // color: "#6D6D6D",
      backgroundColor: "#FFFFFF",
      transitionDuration: "0.1s",
      display: "flex",
      justifyContent: "space-between",
      ...(style == null ? void 0 : style.menuItem) || {}
    },
    menuItemHover: {
      filter: "brightness(98%)",
      ...(style == null ? void 0 : style.menuItemHover) || {}
    },
    menuItemSelected: {
      // color: color || null,
      fontWeight: "bold",
      ...(style == null ? void 0 : style.menuItemSelected) || {}
    },
    spacer: {
      height: "1px",
      marginLeft: "16px",
      marginRight: "16px",
      backgroundColor: "#DCDCDB",
      ...(style == null ? void 0 : style.spacer) || {}
    },
    error: {
      ...(style == null ? void 0 : style.error) || {}
    },
    dropdownSubMenu: {
      position: "absolute",
      zIndex: "1",
      left: "100%",
      top: 0,
      border: "solid 1px #AEAEAE",
      borderRadius: "0 0 6px 6px",
      boxShadow: "0 4px 14px 0 rgba(202,202,202,0.5)",
      padding: "12px",
      marginLeft: "16px",
      backgroundColor: "#FFFFFF",
      transitionDuration: "0.1s",
      whiteSpace: "nowrap",
      outline: "none",
      // width: '100%',
      // maxWidth: '100%',
      overflow: "visible",
      cursor: "default",
      ...(style == null ? void 0 : style.dropdownSubMenu) || {}
    }
  };
  const handleClose = () => {
    setHoveredItem(null);
    setClickedItem(null);
    onClose();
  };
  const handleSelect = (newValue, item, e) => {
    if (item == null ? void 0 : item.subItems) {
      setClickedItem(newValue);
      return;
    }
    if (item == null ? void 0 : item.onSelect) {
      item.onSelect(newValue, e);
    } else {
      onSelect(newValue, e);
    }
    handleClose();
  };
  const itemHeight = 54;
  const keyActions = [
    {
      key: "ArrowDown",
      action: (e) => {
        var _a;
        e.preventDefault();
        if (hoveredItem === null) {
          setHoveredItem(0);
        } else {
          const nextItem = hoveredItem + 1;
          if (nextItem < sortedItems.length) {
            setHoveredItem(nextItem);
            (_a = listRef == null ? void 0 : listRef.current) == null ? void 0 : _a.scrollTo({
              top: hoveredItem * itemHeight,
              behavior: "smooth"
            });
          }
        }
      }
    },
    {
      key: "ArrowUp",
      action: (e) => {
        var _a;
        e.preventDefault();
        if (hoveredItem === null) {
          setHoveredItem(0);
        } else {
          const previousItem = hoveredItem - 1;
          if (previousItem >= 0) {
            setHoveredItem(previousItem);
            (_a = listRef == null ? void 0 : listRef.current) == null ? void 0 : _a.scrollTo({
              top: (hoveredItem - 1) * itemHeight,
              behavior: "smooth"
            });
          }
        }
      }
    },
    {
      key: "Enter",
      action: (e) => {
        var _a, _b;
        if (hoveredItem === null && sortedItems.length === 1) {
          handleSelect((_a = sortedItems[0]) == null ? void 0 : _a.value, sortedItems[0], e);
        } else if (hoveredItem !== null) {
          handleSelect((_b = sortedItems[hoveredItem]) == null ? void 0 : _b.value, sortedItems[hoveredItem], e);
        }
      }
    }
  ];
  useKeyboardListener(listRef, onBlur, keyActions);
  const setRef = (ref) => {
  };
  return /* @__PURE__ */ React__default.createElement(Box, { style: dropdownStyles.outerContainer }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, sortedItems.filter((item) => value !== null || (item == null ? void 0 : item.value) !== null).map((item, i) => /* @__PURE__ */ React__default.createElement(Box, { key: !isEmpty(item == null ? void 0 : item.key) ? item.key : item.value }, /* @__PURE__ */ React__default.createElement(
    Box,
    {
      ref: setRef,
      style: {
        ...dropdownStyles.menuItem,
        ...item.value === value && value !== null ? dropdownStyles.menuItemSelected : {},
        ...i === hoveredItem ? dropdownStyles.menuItemHover : {}
      },
      className: `dropdown-menu-item ${i === hoveredItem ? "dropdown-menu-item-hovered" : ""}`,
      onClick: (e) => {
        e.stopPropagation();
        handleSelect(item.value, item, e);
      },
      onMouseEnter: () => setHoveredItem(i)
    },
    /* @__PURE__ */ React__default.createElement(Box, null, item.label),
    /* @__PURE__ */ React__default.createElement(Box, null, (item == null ? void 0 : item.subItems) && /* @__PURE__ */ React__default.createElement(SvgUpArrow, { style: { marginBottom: "2px", transform: "rotate(90deg)" } }))
  ), i < (items == null ? void 0 : items.length) - 1 && /* @__PURE__ */ React__default.createElement(Box, { style: dropdownStyles.spacer })))), (selectedClickedItem == null ? void 0 : selectedClickedItem.subItems) && /* @__PURE__ */ React__default.createElement(Box, { style: dropdownStyles.dropdownSubMenu }, Array.isArray(selectedClickedItem == null ? void 0 : selectedClickedItem.subItems) ? /* @__PURE__ */ React__default.createElement(
    DropdownSubMenu,
    {
      items: selectedClickedItem == null ? void 0 : selectedClickedItem.subItems,
      style,
      onSelect: handleSelect,
      onClose
    }
  ) : selectedClickedItem == null ? void 0 : selectedClickedItem.subItems(onClose)));
};
DropdownSubMenu.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      // Optional param used for the key. Useful if the value is not serializable
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
      // eslint-disable-next-line react/forbid-prop-types
      value: PropTypes.any,
      subItems: PropTypes.func
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  direction: PropTypes.string,
  style: PropTypes.shape({}),
  classes: PropTypes.shape({})
};
export {
  DropdownSubMenu
};
//# sourceMappingURL=DropdownSubMenu.js.map
